import {  inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { FuseMockApiService } from '@fuse/lib/mock-api';
import { Store } from '@ngrx/store';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { ReclamoResponseData } from 'app/interfaces/reclamos.interface';
import { compactNavigation, defaultExternalNavigation, defaultNavigation, futuristicNavigation, horizontalExternalNavigation, horizontalNavigation } from 'app/mock-api/common/navigation/data';
import { ClaimService } from 'app/services/claim.service';
import { AppState } from 'app/store/app.reducer';
import { cloneDeep } from 'lodash-es';
import { filter } from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class NavigationMockApi
{
    // private readonly _compactNavigation: FuseNavigationItem[] = compactNavigation;
    // private readonly _defaultNavigation: FuseNavigationItem[] = defaultNavigation;
    // private readonly _defaultExternalNavigation: FuseNavigationItem[] = defaultExternalNavigation;
    // private readonly _futuristicNavigation: FuseNavigationItem[] = futuristicNavigation;
    // private readonly _horizontalNavigation: FuseNavigationItem[] = horizontalNavigation;
    // private readonly _horizontalExternalNavigation: FuseNavigationItem[] = horizontalExternalNavigation;
    private userRole: string = '';
    private userGroup: string = '';
    private userEmail: string = '';
    private currentRoute: string = '';
    private ticketsBadgeCount = 0;
    private refreshRate = 300000; // Pide tickets cada 5 minutos
    private ticketsBlackList: {id: string, date: Date}[] = [];

    private router = inject(Router)

    /**
     * Constructor
     */
    constructor(private _fuseMockApiService: FuseMockApiService,
        private _store: Store<AppState>,
        private _reclamosService: ClaimService,
        private _navigationService: NavigationService,
    )
    {
        // Register Mock API handlers
        this.registerHandlers();
        _store.select('auth').subscribe((auth) => {
            this.userRole = auth.auth?.userRole ?? '';
            this.userGroup = auth.auth?.userGroup ?? '';
            this.userEmail = auth.auth?.userEmail ?? '';
            if (this.userGroup.includes('ITC SOLUCIONES') && this.userRole.includes('OPERADOR')) {
            this.getTickets();
            setInterval(() => {
                if (!this.currentRoute.includes('/tickets') && !this.currentRoute.includes('/sign-in') && !this.currentRoute.includes('/sign-up') && this.userRole.includes('OPERADOR')){
                    this.getTickets();
                }
            }, this.refreshRate);
        }
        });

        this.router.events.pipe(
                filter(event => event instanceof NavigationEnd)
            ).subscribe((event: any) => {
                if (event.url.includes('/tickets') || event.url.includes('/sign-in') || event.url.includes('/sign-up')) {
                    this.updateTicketsBadgeCount(0);
                }
                this.currentRoute = event.url;
                this.registerHandlers();
            });


    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------
    updateTicketsBadgeCount(count: number): void
    {
        // Update the badge count first so the mock GET will return the updated navigation,
        // then re-register handlers and trigger a fetch to emit the new navigation to subscribers.
        this.ticketsBadgeCount = count;
        this.registerHandlers();
        this._navigationService.get().subscribe();
    }

    getTickets(): void {
        const date = new Date();
        const daysago = new Date(date.getTime() - 86400000);
        if (this.userRole.includes('OPERADOR') && this.userGroup.includes('ITC SOLUCIONES')) {
            this._reclamosService.getTicketsByParameters(
                { idEstado: '1', emailOperador: this.userEmail, fechaDesde: daysago.toISOString().slice(0, 10), fechaHasta: date.toISOString().slice(0, 10) },
                0,
                50
            ).then((response) => {

                // Guarda los tickets abiertos de los últimos 5 minutos y los guarda en una lista negra
                for (let ticket of response.response.data) {
                    const fechaCreacion = new Date(ticket.fechaCreacion);
                    const ultimoRefresco = new Date(date.getTime() - this.refreshRate);
                    const estaEnListaNegra = this.ticketsBlackList.find((t) => String(t.id) === String(ticket.id));
                    const ticketAbierto = !ticket.cerrado
                    if (fechaCreacion > ultimoRefresco && !estaEnListaNegra && ticketAbierto) {
                        this.ticketsBlackList.push({ id: String(ticket.id), date: ticket.fechaCreacion });
                        this.updateTicketsBadgeCount(this.ticketsBadgeCount + 1);
                    }
                }
                const unDiaDespues = 86400000;

                // Limpia los tickets en la lista negra después de 24 horas guardados
                this.ticketsBlackList = this.ticketsBlackList.filter((savedTicket) => {
                    const timePassed = new Date().getTime() - new Date(savedTicket.date).getTime();
                    return timePassed <= unDiaDespues;
                });
            })
        }
    }

    /**
     * Register Mock API handlers
     */
    registerHandlers(): void
    {
        // -----------------------------------------------------------------------------------------------------
        // @ Navigation - GET
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onGet('api/common/navigation')
            .reply(() =>
            {

                if (this.userGroup.includes('OSDE')){
                    // Return the response
                    return [
                        200,
                        {
                            compact   : cloneDeep(compactNavigation( this.userRole.toLowerCase())),
                            default   : cloneDeep(defaultExternalNavigation( this.userRole.toLowerCase())),
                            futuristic: cloneDeep(futuristicNavigation( this.userRole.toLowerCase())),
                            horizontal: cloneDeep(horizontalExternalNavigation( this.userRole.toLowerCase())),
                        },
                    ];
                } else {
                    // Return the response
                    return [
                        200,
                        {
                            compact   : cloneDeep(compactNavigation( this.userRole.toLowerCase())),
                            default   : cloneDeep(defaultNavigation( { role: this.userRole.toLowerCase(), group: this.userGroup.toLowerCase()}, this.currentRoute, this.ticketsBadgeCount)),
                            futuristic: cloneDeep(futuristicNavigation( this.userRole.toLowerCase())),
                            horizontal: cloneDeep(horizontalNavigation( this.userRole.toLowerCase())),
                        },
                    ];
                }
            });
    }
}
